import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { SeoHead } from "@/components/seo/SeoHead";
// Versão 1 do mascote pintado, fixa (a home roda as 4 — ver src/lib/mascote-do-dia.ts)
import mascotImage from "@/assets/mascote/mascote-1.webp";

/**
 * 404. Reescrita em 2026-10-20: estava em inglês ("Oops! Page not found"),
 * cinza e sem marca. Agora segue a paleta do mascote (papel creme, marrom do
 * contorno, turquesa) e devolve a pessoa para a home, onde estão os grupos.
 */
const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-12">
      <SeoHead path="/404/" title="Página não encontrada — Macaco das Promos" noindex />
      <main className="w-full max-w-[420px] text-center">
        <div className="mx-auto h-32 w-32 rounded-full bg-[#fffdf8] p-[5px] shadow-[0_14px_30px_-14px_rgba(29,106,122,0.6)]">
          <img
            src={mascotImage}
            alt="Macaco das Promos, o mascote"
            width={512}
            height={512}
            className="h-full w-full rounded-full object-cover"
          />
        </div>

        <p className="mt-6 text-[13px] font-extrabold uppercase tracking-[0.14em] text-[#6b5a4e]">
          Erro 404
        </p>
        <h1 className="mt-2 font-['Bricolage_Grotesque','Plus_Jakarta_Sans',sans-serif] text-[clamp(26px,7vw,34px)] font-extrabold leading-tight tracking-[-0.02em] text-[#2b201a] [text-wrap:balance]">
          Essa promo sumiu do radar.
        </h1>
        <p className="mx-auto mt-3 max-w-[32ch] text-base leading-relaxed text-[#6b5a4e] [text-wrap:balance]">
          A página não existe ou o link expirou. As promos novas chegam todo dia
          nos grupos.
        </p>

        <a
          href="/"
          className="mt-7 inline-flex h-12 items-center justify-center rounded-2xl bg-[#1d6a7a] px-7 font-bold text-white shadow-[0_12px_24px_-12px_rgba(29,106,122,0.8)] transition-colors hover:bg-[#175866] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#1d6a7a] focus-visible:ring-offset-2 focus-visible:ring-offset-[#fffbef]"
        >
          Voltar para o início
        </a>
      </main>
    </div>
  );
};

export default NotFound;
